import { Injectable } from '@angular/core';
import { ApiFeatureSelector, Filter, Pagination } from '@iot-platform/models/common';
import { State, adapter, userApiKeysFeature } from '../reducers/user-api-keys.reducer';
import { UserApiKey } from '@iot-platform/models/i4b';

@Injectable({
  providedIn: 'root'
})
export class UserApiKeysSelectors extends ApiFeatureSelector<State, UserApiKey, Pagination, Filter> {
  constructor() {
    super(userApiKeysFeature.selectUserApiKeysState, adapter);
  }
}
